<template>
  <div class="transparent-tab">
    <div class="transparent-tab-wrapper">
      <div class="m-panel-body">
        <!-- 提取的树形组件内容 -->
        <div class="m-panel-body-sub">
          <a-alert type="info" :showIcon="true" class="dark-alert">
            <div slot="message" class="alert-message">
              {{ $t('当前选择：') }}<span v-if="localSelected.name" class="selected-name">{{ localSelected.name }}</span>
              <a v-if="localSelected.name" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
            </div>
          </a-alert>
          <div style="display: flex;margin-top: 10px;">
            <a-input-search v-model="searchAreaValue" class="tree-search" allowClear :placeholder="$t('请输入分区名称')" />
          </div>
          <!-- 树形结构 -->
          <a-col :md="24" :sm="24" class="new-tree-col">
            <template>
              <a-spin tip="Loading..." :spinning="areaLoading">
                <el-tree
                  class="dark-tree"
                  :data="areaTree"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  :filter-node-method="filterNode"
                  :check-on-click-node="true"
                  :check-strictly="checkStrictly"
                  :highlight-current="true"
                  node-key="id"
                  :current-node-key="currentNodeKey"
                  :default-expanded-keys="iExpandedKeys"
                  @node-click="nodeClick"
                  ref="areaTree"
                >
                </el-tree>
              </a-spin>
            </template>
          </a-col>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {postAction} from '@/api/manage'
import CONFIG from '@/views/DMAPartitionMetering/PipelineNetMap/module/config/GIS_Config'
export default {
  name: 'AreaTreeCard',
  props: {
    areaLoading: Boolean,
    currSelected: Object,
  },
  data() {
    return {
      visible: true,
      title: this.$t('分区树'),
      width: 800,
      disableSubmit: false,
      confirmLoading: false,
      searchAreaValue: '',
      defaultProps: {
        children: 'areaList',
        label: 'name',
        value: 'code',
      },
      checkStrictly: false,
      currentNodeKey: null,
      iExpandedKeys: [],
      areaTree: [],
      localSelected: {}, // 本地选中状态，避免直接修改prop
      url: {
        queryAreaTree: '/jeecg-gis/area/queryAreaTree',
      },
    }
  },
  watch: {
    searchAreaValue(val) {
      this.$refs.areaTree.filter(val)
    },
    // 监听父组件传递的currSelected变化，同步到本地状态
    currSelected: {
      handler(newVal) {
        this.localSelected = newVal || {}
        if (newVal && newVal.code) {
          this.currentNodeKey = newVal.code
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() { 
    this.loadAreaTree();
  },
  methods: {
    loadAreaTree() {
      let params = {
        projectCode: CONFIG.TopologyProjection,
        topologyCode: CONFIG.TopologyCode,
      }
      postAction(this.url.queryAreaTree, params).then(res => {
        if (res.success) {
          this.areaTree = res.result
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleOpenOrClose() {
      this.visible = !this.visible
      this.$emit('toggle-visibility', this.visible)
    },

    // 树相关方法
    nodeClick(record, node) {
      this.currentNodeKey = record.code;
      this.localSelected = record; // 修改本地状态而不是prop
      this.$refs.areaTree.setCheckedKeys([record.code])
      this.$emit('node-selected', record)
    },

    unselect() {
      this.localSelected = {} // 重置本地状态
      this.currentNodeKey = null
      if (this.$refs.areaTree) {
        this.$refs.areaTree.setCheckedKeys([])
      }
      this.$emit('unselect')
    },

    collapseAll() {
      this.$emit('collapse-all')
    },

    handleAreaAdd() {
      this.$emit('area-add')
    },

    handleAdd(node, data) {
      this.$emit('add-child', node, data)
    },

    handleDelete(node, data) {
      this.$emit('delete', node, data)
    },
    // 节点过滤方法（保持原样）
    filterNode(value, data) {
      if (!value) return true
      return data.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
    },
  },
}
</script>
<style scoped>
</style>
